import { useMemo } from 'react';
import { Icon } from './icons';

interface FloatingParticlesProps {
  count?: number;
  icons?: string[];
  className?: string;
  /** Vertical travel distance in px over one animation cycle — scale this to the container's height. */
  rise?: number;
}

const DEFAULT_ICONS = ['sparkle', 'check', 'bug', 'zap', 'shield-check', 'terminal'];

export default function FloatingParticles({ count = 10, icons = DEFAULT_ICONS, className = '', rise = 220 }: FloatingParticlesProps) {
  const particles = useMemo(() => Array.from({ length: count }, (_, i) => ({
    icon: icons[i % icons.length],
    left: Math.random() * 96,
    delay: -(Math.random() * 18),
    duration: 14 + Math.random() * 12,
    size: 12 + Math.random() * 12,
    drift: (Math.random() - 0.5) * 80,
  })), [count, icons]);

  return (
    <div className={`floating-particles ${className}`} aria-hidden="true">
      {particles.map((p, i) => (
        <span
          key={i}
          className={`floating-particle ${i % 2 === 0 ? 'floating-particle-accent' : 'floating-particle-red'}`}
          style={{
            left: `${p.left}%`,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            '--drift': `${p.drift}px`,
            '--rise': `${rise}px`,
          } as React.CSSProperties}
        >
          <Icon name={p.icon} size={p.size} />
        </span>
      ))}
    </div>
  );
}
